import { PushV7 } from '../../api/dashboardV7/pushV7';

export class CommercialPushViewModel {
    public simPush?: PushV7;
    public homePush?: PushV7;
    public entertainmentPush?: PushV7;
}
